"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.split = split;
exports.default = void 0;

var _map = require("../$map/map");

function* iterableOf(item) {
  yield item;
}

function split(source) {
  if (typeof source === 'string') {
    return source;
  } else {
    return (0, _map.map)(source, item => iterableOf(item));
  }
}

var _default = split;
exports.default = _default;